import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface IRemoveEmaacItemDialogData {
  messageKey: string;
}

@Component({
  selector: 'app-remove-emaac-item-dialog',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [MatDialogModule, TranslateModule],
  templateUrl: './remove-emaac-item-dialog.component.html'
})
export class RemoveEmaacItemDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<RemoveEmaacItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRemoveEmaacItemDialogData
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
